import { format } from 'date-fns';
import { RequestType, ServerRequestType } from './types';

export const transformRequest = (formData: RequestType): ServerRequestType => {
  const { identifier, driver, address } = formData;
  return {
    insurableParty: {
      firstName: driver[identifier].firstName,
      lastName: driver[identifier].lastName,
      middleName: driver[identifier].middleName || '',
      suffix: driver[identifier].suffix || '',
      dateOfBirth: format(
        Date.parse(driver[identifier].dateOfBirth),
        'yyyy-MM-dd'
      ),
    },
    address: {
      addressLineOne: address[identifier].address1,
      addressLineTwo: address[identifier].address2 || '',
      city: address[identifier].city,
      state: address[identifier].state,
      postalCode: address[identifier].zip,
    },
  };
};
